import React from 'react';
import { AutoSizer, List } from 'react-virtualized';

/** Must pass in a rowGenerator function that expects one datum as a parameter and returns a React component * */
class SelectList extends React.Component {
  constructor(props) {
    super(props);
  }

  _noRowsRenderer = () => <div className="list-no-rows">No Data</div>;

  _getDatum = index => {
    const { data } = this.props;
    return data.get(index % data.size);
  };

  _rowRenderer = ({ index, isScrolling, key, style }) => {
    const { onSelect, rowGenerator } = this.props;
    const datum = this._getDatum(index);
    const selectable = datum.get('selectable', true);

    return selectable ? (
      <div className={'list-row-selectable'} key={key} style={style} onClick={() => onSelect(datum)}>
        {rowGenerator(datum)}
      </div>
    ) : (
      <div className={'list-row-non-selectable'} key={key} style={style}>
        {rowGenerator(datum)}
      </div>
    );
  };

  render() {
    const { data, height } = this.props;

    return (
      <div style={{ width: '100%' }}>
        <AutoSizer disableHeight>
          {({ width }) => (
            <List
              dataForRerender={data}
              className="rv-list"
              height={height || 400}
              overscanRowCount={10}
              noRowsRenderer={this._noRowsRenderer}
              rowCount={data.size}
              rowHeight={35}
              rowRenderer={this._rowRenderer}
              width={width}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}

export default SelectList;
